module.exports = __webpack_public_path__ + "img/27_10.2ab329b0.png";